// assets/js/cross-site-notification.js

export const initCrossSiteNotification = () => {
    const notificationBox = document.getElementById('cross-site-notification');
    
    // Si l'élément n'existe pas dans le HTML, on s'arrête là (sécurité)
    if (!notificationBox) return;

    const currentHost = window.location.hostname; // ex: hi-technologies.ch
    const referrer = document.referrer; // ex: https://hi-technologies.fr/page...

    // LOGIQUE : 
    // 1. Je suis sur le site SUISSE (.ch)
    // 2. ET je viens du site FRANCE (.fr)
    if (currentHost.includes('.ch') && referrer.includes('hi-technologies.fr')) {
        
        // On injecte le texte
        notificationBox.innerHTML = `
            <div class="content">
                <span>🇨🇭</span>
                <span>Vous consultez le site Suisse <strong>Hi-technologies.ch</strong></span>
            </div>
        `;

        // On affiche via la classe CSS
        notificationBox.classList.add('is-visible');

        // (Optionnel) Masquer après 5 secondes
        setTimeout(() => {
            notificationBox.classList.remove('is-visible');
        }, 5000);
    }
};